import React, { useEffect, useState } from 'react';
import './Hero.css';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);

  const tickerItems = [
    'GST Registration',
    'Company Incorporation',
    'Income Tax Filing',
    'Trademark & IP Services',
    'Accounting & Bookkeeping',
    'Insurance & Financial Planning'
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      {/* Animated background elements */}
      <div className="hero-bg-elements">
        <div className="floating-shape shape-1" style={{ transform: `translateY(${scrollY * 0.5}px)` }}></div>
        <div className="floating-shape shape-2" style={{ transform: `translateY(${scrollY * 0.3}px)` }}></div>
        <div className="floating-shape shape-3" style={{ transform: `translateY(${scrollY * 0.4}px)` }}></div>
        <div className="floating-circle circle-1"></div>
        <div className="floating-circle circle-2"></div>
        <div className="floating-circle circle-3"></div>
      </div>

      <div className="hero-info-bar">
        <div className="hero-info-track">
          {[...tickerItems, ...tickerItems].map((item, index) => (
            <div key={`${item}-${index}`} className="hero-info-item">
              <span className="hero-info-dot" aria-hidden="true"></span>
              <span className="hero-info-text">{item}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="container">
        <div className="hero-content" style={{ transform: `translateY(${scrollY * 0.2}px)` }}>
          <div className="hero-text">
            <h1>Your Trusted Partner for <span>GST & Financial Services</span></h1>
            <p>We provide comprehensive solutions for GST Registration, Income Tax Filing, Company Registration, and more. Expert guidance at affordable prices.</p>
            <div className="hero-buttons">
              <button className="btn btn-primary" onClick={scrollToContact}>
                <i className="fas fa-phone-alt"></i> Get Free Consultation
              </button>
              <button className="btn btn-secondary" onClick={scrollToContact}>
                <i className="fas fa-calculator"></i> Calculate Price
              </button>
            </div>
            <div className="hero-features">
              <div className="feature-item">
                <i className="fas fa-check-circle"></i>
                <span>10,000+ Happy Clients</span>
              </div>
              <div className="feature-item">
                <i className="fas fa-check-circle"></i>
                <span>Expert CA & CS Team</span>
              </div>
              <div className="feature-item">
                <i className="fas fa-check-circle"></i>
                <span>100% Online Process</span>
              </div>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-card">
              <i className="fas fa-file-invoice-dollar"></i>
              <h3>GST Registration</h3>
              <p>Starting from ₹999</p>
            </div>
            <div className="hero-card">
              <i className="fas fa-building"></i>
              <h3>Company Registration</h3>
              <p>Starting from ₹6,999</p>
            </div>
            <div className="hero-card">
              <i className="fas fa-coins"></i>
              <h3>Income Tax Filing</h3>
              <p>Starting from ₹1,499</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
